import { render, staticRenderFns } from "./UmkmBermitraMainMap.vue?vue&type=template&id=50db5486&scoped=true"
import script from "./UmkmBermitraMainMap.vue?vue&type=script&lang=js"
export * from "./UmkmBermitraMainMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50db5486",
  null
  
)

export default component.exports